module.exports = __webpack_public_path__ + "img/cardShowFive.6a8b3598.png";